import {
  MessageStickerCreateModel,
  MessageStickerUpdateModel
} from './message-sticker.model';

export class LoadMessageStickersAction {
  static readonly type = '[Messages] Load messages stickers';
}

export class SaveNewMessageStickerAction {
  static readonly type = '[Messages] Save new message';
  constructor(public payload: MessageStickerCreateModel) {}
}

export class UpdateMessageStickerAction {
  static readonly type = '[Messages] Update message';
  constructor(public payload: MessageStickerUpdateModel) {}
}

export class DeleteMessageStickerAction {
  static readonly type = '[Messages] Delete message';
  constructor(public payload: number) {}
}
